/*
 * brand.js - Sets the title and colours to use
 */
'use strict';

Sao.config.title = 'Lawmens';
Sao.config.icon_colors = '#00a3da,#777,#d9534f'.split(',');
var colorSet = [
    '#017DBA', '#00A6F9', '#6DCFFF', '#86AC40', '#56CA00', '#A2D12E',
    '#7879F1', '#A5A6F6', '#FFB400', '#FFD98F', '#B9B9C3', '#E6E7E8'
];

Sao.common.generateColorscheme = function(masterColor, keys, light=0.1) {
    var colors = {};
    for (var i = 0; i < keys.length; i++) {
        var colorIndex = i % colorSet.length;
        var color = colorSet[colorIndex];

        if (keys.length > 12 && i >= 12) {
            var rgb = Sao.common.hex2rgb(
                Sao.common.COLOR_SCHEMES[color] || color);
            var hsv = Sao.common.rgb2hsv(rgb);
            var h = hsv[0],
                s = hsv[1],
                v = hsv[2];
            light = Math.min(light, (1 - v) / keys.length);
            colors[keys[i]] = Sao.common.rgb2hex(Sao.common.hsv2rgb(
                [(h) % 1, s, (v + light * i) % 1]));
        } else {
            colors[keys[i]] = color;
        }
    }
    return colors;
};
